import React, { useEffect, useState } from "react";
import { ArrowRight, BadgeCheck, Flame, MessageCircle, ShieldCheck, Truck } from "lucide-react";
import { Link } from "react-router-dom";
import { getOfertasVirales } from "../config/firebase";
import { buildWhatsAppUrl } from "../config/store";
import "./ViralOffersShowcase.css";

export default function ViralOffersShowcase({ compact = false }) {
  const [offers, setOffers] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getOfertasVirales({ onlyActive: true }).then(setOffers).catch(() => setOffers([]));
  }, []);

  const visible = compact ? offers.slice(0, 3) : offers;
  if (!offers.length) return null;

  return <section className={`viral-showcase ${compact ? "compact" : ""}`}>
    <div className="viral-showcase__head">
      <div><span><Flame />Tendencias ROMI</span><h2>Ofertas virales del momento</h2><p>Productos que están causando sensación en TikTok, con promociones especiales y pago contra entrega.</p></div>
      {compact && <Link to="/ofertas-virales">Ver todas las ofertas <ArrowRight /></Link>}
    </div>
    <div className="viral-offer-grid">{visible.map((offer) => {
      const hero = offer.imagenPrincipal?.url || offer.imagenPrincipal;
      return <article className="viral-offer-card" key={offer.id}>
        <button className="viral-offer-card__image" onClick={() => setSelected(offer)}><img src={hero} alt={offer.titulo} loading="lazy" /><span><Flame />Viral en TikTok</span></button>
        <div><h3>{offer.titulo}</h3><p>{offer.descripcion}</p><div className="viral-offer-card__proof"><span><Truck />Envío gratis</span><span><ShieldCheck />Pago al recibir</span></div><button onClick={() => setSelected(offer)}>Ver oferta <ArrowRight /></button></div>
      </article>;
    })}</div>
    {selected && <OfferDialog offer={selected} close={() => setSelected(null)} />}
  </section>;
}

function OfferDialog({ offer, close }) {
  const hero = offer.imagenPrincipal?.url || offer.imagenPrincipal;
  const promotion = offer.imagenOferta?.url || offer.imagenOferta;
  const message = `Hola ROMI STORE. Me interesa la oferta viral “${offer.titulo}” que vi en la tienda. Quiero conocer las opciones disponibles y realizar mi pedido.`;
  return <div className="viral-offer-modal" role="dialog" aria-modal="true" aria-label={`Oferta ${offer.titulo}`}>
    <button className="viral-offer-modal__backdrop" onClick={close} aria-label="Cerrar oferta" />
    <section><button className="viral-offer-modal__close" onClick={close} aria-label="Cerrar">×</button><div className="viral-offer-modal__images"><img src={hero} alt={`${offer.titulo} presentación`} /><img src={promotion} alt={`${offer.titulo} oferta`} /></div><div className="viral-offer-modal__copy"><span><Flame />Oferta viral activa</span><h2>{offer.titulo}</h2><p>{offer.descripcion}</p><div><BadgeCheck />Revisa las opciones y precios indicados en la imagen de la promoción.</div><a href={buildWhatsAppUrl(message)} target="_blank" rel="noreferrer"><MessageCircle />Quiero esta oferta por WhatsApp</a><small>Confirma con nuestro asesor la opción que deseas. Pagas cuando recibes tu pedido.</small></div></section>
  </div>;
}
